import Modal from './Modal';
// import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';
import {CleanUrl} from "../../../utils/cleanUrl";

const ModalVideoUserResponse = (props) => {
    const { handleModal, modalResponse, modalPrizeTitle } = props;
    const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);
    const { t } = useTranslation();
    
    // const config = {
    //     ADD_ATTR: ['target']
    // };

    // DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    //     if (node.tagName.toLowerCase() === 'a') {
    //         node.setAttribute('target', '_blank');
    //     }
    // });

    // const sanitizedLegal = DOMPurify.sanitize(promotionSettings.promotion_type.where_to_find_code_text, config);

    return (
        <Modal>
            <div className="pweu-modal-overlay">
                <div className="pweu-modal">
                    <div className="pweu-close-modal" onClick={handleModal}>
                        <img src={imagePath + "delete--white.svg"} alt="" />
                    </div>
                    <div className="pweu-modal-content">
                        <h3 classname="prize-title-headline">{modalResponse} <span>{modalPrizeTitle}</span></h3>
                        <a href={window.promotionHome} className="btn btn-primary" onClick={handleModal}>{t("Got it, thanks!")}</a>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ModalVideoUserResponse;
